/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useState } from 'react';
import { authSelectors } from '../../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../../app/resource/user/user.selectors';
import { useSelect, useSelectWithParams } from '../../../../../../utils/selector.utils';
import { IParticipantProps } from './types';
import { CircularAvatar } from '../../../../common/CustomAvatar';

export const Participant: FunctionComponent<IParticipantProps> = ({ userId, provided }) => {
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);
  const [toggle, setToggle] = useState(false);
  const loggedUser = useSelect(authSelectors.selectLoggedUser);

  return (
    user && (
      <div
        className={`dropdown mr-1 mb-1 ${toggle ? 'opened' : ''}`}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
      >
        <a
          className="btn white-bg darkGray dropdown-button small-shadow f-14 mx-0"
          data-action="dropdown"
          title={`${user.firstName} ${user.lastName}`}
          onClick={() => setToggle(!toggle)}
        >
          <span className="small-avatar mr-1">
            <CircularAvatar src={user.image} title={`${user.firstName} ${user.lastName}`} />
            {loggedUser === user.id && (
              <span className="status-badge green-bg">
                <i className="icon-check" />
              </span>
            )}
          </span>
          {`${user.firstName} ${user.lastName}`}
        </a>
        <ul className="dropdown-menu no-lines">
          <li>
            <a href="" className="drop-item darkGray">
              <i className="icon2-at mr-1 blueGray" /> {user.email ? user.email : '/'}
            </a>
          </li>
          <li>
            <a href="" className="drop-item darkGray">
              <i className="icon2-phone mr-1 blueGray" /> {user.phone ? user.phone : '/'}
            </a>
          </li>
          {/* <li>
          <a href="" className="drop-item darkGray">
            <i className="icon2-hangouts mr-1 blueGray" /> {user.facebook ? user.facebook : '/'}
          </a>
        </li> */}
          {/* <li>
          <a href="" className="drop-item darkGray">
            <i className="icon2-skype mr-1 blueGray" /> {user.skype ? user.skype : '/'}
          </a>
        </li> */}
        </ul>
      </div>
    )
  );
};
